if (!customElements.get('landing-tabs')) {
  customElements.define(
    'landing-tabs',
    class LandingTabs extends HTMLElement {
      connectedCallback() {
        this.buttons = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];

        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => this.select(index));
          button.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        this.addEventListener('shopify:block:select', (event) => {
          const index = this.panels.indexOf(event.target.closest('[role="tabpanel"]'));
          if (index > -1) this.select(index);
        });
      }

      select(index, focus = false) {
        this.buttons.forEach((button, i) => {
          const active = i === index;
          button.setAttribute('aria-selected', active);
          button.tabIndex = active ? 0 : -1;
          if (!this.panels[i]) return;
          this.panels[i].hidden = !active;
          if (!active) this.panels[i].querySelectorAll('video').forEach((video) => video.pause());
        });
        if (focus) this.buttons[index].focus();
      }

      onKeydown(event, index) {
        const last = this.buttons.length - 1;
        const target = {
          ArrowRight: index === last ? 0 : index + 1,
          ArrowLeft: index === 0 ? last : index - 1,
          Home: 0,
          End: last,
        }[event.key];
        if (target === undefined) return;
        event.preventDefault();
        this.select(target, true);
      }
    }
  );
}

if (!customElements.get('landing-slider')) {
  customElements.define(
    'landing-slider',
    class LandingSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.landing-slider__track');
        this.prev = this.querySelector('.landing-slider__btn--prev');
        this.next = this.querySelector('.landing-slider__btn--next');
        if (!this.track) return;

        this.update = this.update.bind(this);
        this.prev?.addEventListener('click', () => this.scrollByPage(-1));
        this.next?.addEventListener('click', () => this.scrollByPage(1));
        this.track.addEventListener('scroll', this.update, { passive: true });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      scrollByPage(direction) {
        this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      }
    }
  );
}
